const StarBordered = (
  theme,
  translateX = 23,
  translateY = 35,
  symbolColor = '',
) => {
  const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  group.setAttribute(
    'transform',
    `scale(0.5) translate(${translateX} ${translateY})`,
  );

  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute(
    'd',
    'm22 9.24-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28z',
  );
  path.setAttribute('fill', 'none');
  path.setAttribute('stroke', symbolColor);

  group.appendChild(path);
  return group;
};

export default StarBordered;
